import { render } from "./CompanySettings.vue?vue&type=template&id=3d328d24&ts=true"
import script from "./CompanySettings.vue?vue&type=script&lang=ts"
export * from "./CompanySettings.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__